module.exports = __webpack_public_path__ + "img/ai_3d_robot.c7ed28db.png";